"use strict";
import { InfieldButton } from "./src/InfieldButton.dev.js";
customElements.define("sp-infield-button", InfieldButton);
//# sourceMappingURL=sp-infield-button.dev.js.map
